export const REGEX_PHONE = /^1\d{10}$/

export const REGEX_EMAIL = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/
